import request from '@/utils/request'
// 校验token是否有效
export function verifyToken(params: any) {
    return request.post({ url: '/index/verifyToken', params })
}
